var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-h-full tw-flex tw-flex-col"},[_c('Dashboard'),_vm._v(" "),_c('Calendar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }